// extracted by mini-css-extract-plugin
export default {"root":"InviteCompleteForm-root-5f7783df07c0471b4393c9ed22184f57"};